var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.7619,
    cy: 21.4287,
    r: 11.7619,
    fill: "white",
    fillOpacity: 0.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.2382,
    cy: 21.4287,
    r: 11.7619,
    fill: "white",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.796653,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0001 30.7003C23.7537 28.5476 25.5238 25.1948 25.5238 21.4286C25.5238 17.6625 23.7537 14.3097 21.0001 12.157C18.2464 14.3097 16.4763 17.6625 16.4763 21.4286C16.4763 25.1948 18.2464 28.5476 21.0001 30.7003Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.254d7a16490cd14e7f75c0b660afcb59.svg";
export { ForwardRef as ReactComponent };